import { Player } from '@/assets/types'
import { defineStore } from 'pinia'
import { Ref, ref } from 'vue'
import { handleSubscription } from './helper'
import { auth, getToken } from '@/assets/utils'
import axios from 'axios'


export const usePlayerStore = defineStore('player', () => {
    const player = ref<Player>({
        name: '',
        sessionId: '',
        score: 0,
        label: ''
    })

    // Load from localStorage on init
    const saved = localStorage.getItem('player')
    if (saved) {
        try {
            const parsed = JSON.parse(saved) as Player
            player.value = parsed
        } catch { }
    }



    async function register(name: string, sessionId: string, label: string) {

        const url = new URL(
            `${import.meta.env.VITE_API_ENDPOINT}/players/register`,
            location.href
        )
        return await axios.post(
            url.toString(),
            {
                name: name,
                sessionId: sessionId,
                label: label,
            }
        ).then(
            (res) => {
                editPlayer(res.data)
                return { errMsg: '', player: res.data }
            }
        ).catch(
            (req) => {
                return { errMsg: req.response.data.error, player: null }
            }
        )
    }


    async function submitAnswer(questionIndex: number, answerIndex: number) {
        const url = new URL(
            `${import.meta.env.VITE_API_ENDPOINT}/answers/submit`,
            location.href

        )
        return await axios.post(
            url.toString(),
            {
                playerId: player.value.id,
                questionIndex: questionIndex,
                answerIndex: answerIndex
            }
        ).then(
            (res) => ({ errMsg: '', answer: res.data })
        ).catch(
            (req) => {
                return { errMsg: req.response.data.error, asnwer: null }
            }
        )
    }

    function reset() {
        localStorage.removeItem('player')
        player.value = {
            name: '',
            sessionId: '',
            score: 0,
            label: '',
        }
    }


    function editPlayer(obj: Player) {
        player.value = obj
        localStorage.setItem(
            'player',
            JSON.stringify(player.value)
        )
    }

    function followPlayers(sessionId: string, arrayRef: Ref<any[]>, counterRef: Ref<number>) {
        return handleSubscription(
            'players',
            {
                create: (doc) => {
                    if (doc.sessionId !== sessionId) return
                    let idx = counterRef.value % 16
                    counterRef.value += 1
                    arrayRef.value[idx] = doc
                },
                update: (doc) => {

                },
                delete: (doc) => {

                },
            }
        )
    }

    async function getPlayers(sessionId: string, limit: number = undefined, options: any = {}) {
        let url = new URL(
            `${import.meta.env.VITE_API_ENDPOINT}/players`,
            location.href
        )

        url.searchParams.set("sessionId", encodeURIComponent(sessionId))
        url.searchParams.set("order", "desc")
        url.searchParams.set("limit", encodeURIComponent(limit))

        Object.entries(options).forEach(([k, v]) => url.searchParams.set(k, encodeURIComponent(v)))

        let res = await auth.get(
            url.toString(),
            getToken()
        )

        let totalPlayers = res.data ?? []

        url = new URL(
            `${import.meta.env.VITE_API_ENDPOINT}/players/count`,
            location.href
        )

        url.searchParams.set("sessionId", encodeURIComponent(sessionId))

        res = await auth.get(
            url.toString(),
            getToken()
        )

        let totalCount = res.data?.count ?? 0

        return {
            players: totalPlayers,
            total: totalCount
        }
    }
    async function getAnswers(sessionId: string, options: any = {}) {
        const url = new URL(
            `${import.meta.env.VITE_API_ENDPOINT}/answers`,
            location.href
        )

        url.searchParams.set("sessionId", encodeURIComponent(sessionId))
        url.searchParams.set("order", "desc")

        Object.entries(options).forEach(([k, v]) => url.searchParams.set(k, encodeURIComponent(v)))

        const res = await auth.get(
            url.toString(),
            getToken()
        )

        let totalPlayers = res.data ?? []
        const totalCount = totalPlayers.length

        return {
            answers: totalPlayers,
            total: totalCount
        }
    }

    async function getPlayersAnswersCount(sessionId: string, questionIndex: number) {
        const url = new URL(
            `${import.meta.env.VITE_API_ENDPOINT}/answers/count`,
            location.href
        )

        url.searchParams.set("sessionId", encodeURIComponent(sessionId))
        url.searchParams.set("questionIndex", encodeURIComponent(questionIndex))
        url.searchParams.set("order", "desc")


        const res = await auth.get(
            url.toString(),
            getToken()
        )

        return res.data?.count ?? 0
    }

    function followPlayersAnswers(sessionId: string, questionIndex: number, counterRef: Ref<number>) {
        return handleSubscription(
            'answers',
            {
                create: (doc) => {
                    if (doc.sessionId !== sessionId) return
                    if (doc.questionIndex !== questionIndex) return
                    counterRef.value += 1
                },
                update: (doc) => {

                },
                delete: (doc) => {

                },
            }
        )
    }

    return { player, register, reset, editPlayer, submitAnswer, followPlayers, getPlayers, followPlayersAnswers, getPlayersAnswersCount, getAnswers }
})
